<section *ngIf="dadosConsulta" [ngClass]="{ 'py-4': dadosConsulta.possuiConsultaVeicular == true  }">


  <app-resumo-resultado [cabecalho]="dadosConsulta" [consulta]="consultas"></app-resumo-resultado>


  <!-- ng-container *ngFor="let c of consultas; let i = index">

    <app-consulta-relatorio-sintetico-plus-cnpj *ngIf="c.tipoConsulta == 'RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PJ'"
      [consulta]='c.consulta' [fotos]='fotos' [observacao]='observacao' [titulo]="c.nome" [idConsulta]="c.id"
      [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [cabecalho]="dadosConsulta">
    </app-consulta-relatorio-sintetico-plus-cnpj>

    <app-consulta-relatorio-sintetico-plus-cpf *ngIf="c.tipoConsulta == 'RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PF'"
      [consulta]='c.consulta' [fotos]='fotos' [observacao]='observacao' [titulo]="c.nome" [idConsulta]="c.id"
      [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [cabecalho]="json">
    </app-consulta-relatorio-sintetico-plus-cpf>

    <app-consulta-relatorio-unificado-cnpj *ngIf="c.tipoConsulta == 'RELATORIO_UNIFICADO_PJ'" [consulta]='c.consulta'
      [fotos]='fotos' [observacao]='observacao' [titulo]="c.nome" [idConsulta]="c.id" [tipoConsulta]="c.tipoConsulta"
      [codigoControle]="c.codigoControle">
    </app-consulta-relatorio-unificado-cnpj>

    <app-consulta-relatorio-unificado-cpf *ngIf="c.tipoConsulta == 'RELATORIO_UNIFICADO_PF'" [consulta]='c.consulta'
      [fotos]='fotos' [observacao]='observacao' [titulo]="c.nome" [idConsulta]="c.id" [tipoConsulta]="c.tipoConsulta"
      [codigoControle]="c.codigoControle">
    </app-consulta-relatorio-unificado-cpf>

  </ng-container -->

  <div class="container-consultas d-flex flex-column">

    <ng-container *ngFor="let c of consultasFilhas; let i = index">

      <app-consulta-score *ngIf="c.tipoConsulta == 'score'" [consulta]='c' titulo="SCORE"
        [tipoConsulta]="c.tipoConsulta">
      </app-consulta-score>

      <ng-container *ngIf="c.tipoPessoa=='PJ'">

        <app-identificacao-cnpj *ngIf="c.tipoConsulta == 'identificacao'" [consulta]='c' titulo="IDENTIFICAÇÃO"
          [tipoConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
        </app-identificacao-cnpj>

      </ng-container>

      <ng-container *ngIf="c.tipoPessoa=='PF'">

        <app-identificacao-cpf  *ngIf="c.tipoConsulta == 'identificacao'" [consulta]='c' titulo="IDENTIFICAÇÃO"
          [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
        </app-identificacao-cpf>

      </ng-container>

      <app-consulta-localizacao  *ngIf="c.tipoConsulta == 'localizacao'" [consulta]='c' titulo="LOCALIZAÇÃO"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-localizacao>

      <app-consulta-scpc-bvs *ngIf="c.tipoConsulta == 'registro_scpc_bvs'" [consulta]="c" titulo="REGISTROS SCPC BVS"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-scpc-bvs>

      <app-consulta-dividas-vencidas *ngIf="c.tipoConsulta == 'divida_vencida_serasa'" [consulta]="c"
        titulo="DÍVIDAS VENCIDAS" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-dividas-vencidas>

      <app-consultas-anteriores *ngIf="c.tipoConsulta == 'consultas_anteriores_sintetico'" [consulta]="c"
        titulo="CONSULTAS ANTERIORES" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consultas-anteriores>

      <app-consulta-protesto *ngIf="c.tipoConsulta == 'protesto'" [consulta]='c' titulo="PROTESTOS"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-protesto>

      <app-consulta-pendencias-financeiras *ngIf="c.tipoConsulta == 'pendencias_financeiras'" [consulta]='c'
        titulo="PENDÊNCIAS FINANCEIRAS" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-pendencias-financeiras>

      <app-consulta-cheque-ordem-ocorrencias *ngIf="c.tipoConsulta == 'cheque_contra_ordem_outras_ocorrencias' || c.tipoConsulta == 'cheque_contra_ordem_ocorrencias' || c.tipoConsulta=='cheque_contra_ordem'" [consulta]='c'
        titulo="CHEQUE - CONTRA ORDEM - OUTRAS OCORRÊNCIAS" [idConsulta]="c.tipoConsulta"
        [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-cheque-ordem-ocorrencias>


      <app-consulta-anteriores-scpc *ngIf="c.tipoConsulta == 'consultas_anteriores_scpc'" [consulta]='c' titulo="CONSULTAS ANTERIORES SCPC"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-anteriores-scpc>

      <!-- até o momento aparece em pf -->
      <app-consulta-restricoes-financeiras *ngIf="c.tipoConsulta == 'restricoes_financeiras'" [consulta]='c'
        titulo="RESTRIÇÕES FINANCEIRAS" [idConsulta]="c.id" [tipoConsulta]="c.tipo" [codigoControle]="c.codigoControle">
      </app-consulta-restricoes-financeiras>



      <!-- em relatorios unificados -->
      <app-protesto-estadual *ngIf="c.tipoConsulta == 'protestos_estaduais'" [consulta]='c' titulo="PROTESTOS ESTADUAIS"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-protesto-estadual>

      <app-consulta-ccf *ngIf="c.tipoConsulta == 'ccf_cadastro_emitentes' || c.tipoConsulta == 'ccf_interno'" [consulta]='c'
        titulo="CCF - CADASTRO DE EMITENTES DE CHEQUES SEM FUNDO" [idConsulta]="c.id" [tipoConsulta]="c.tipo"
        [codigoControle]="c.codigoControle">
      </app-consulta-ccf>

      <app-consulta-participacao-empresas *ngIf="c.tipoConsulta == 'participacao_empresas'" [consulta]='c'
        titulo="PARTICIPAÇÕES EM EMPRESAS" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-participacao-empresas>


      <!-- Não vi serem formatadas porem estão aqui... vai que... -->

      <app-consulta-grafias *ngIf="c.tipoConsulta == 'grafias'" [consulta]='c' titulo="GRAFIAS"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-grafias>

      <app-consulta-referencia-negocios *ngIf="c.tipoConsulta == 'referencias_negocios'" [consulta]='c'
        titulo="REFERENCIAS - NEGOCIOS" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-referencia-negocios>

      <app-consulta-registro-debito *ngIf="c.tipoConsulta == 'registro_debito'" [consulta]='c'
        titulo="REGISTRO - DEBITO" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-registro-debito>

      <app-consulta-historico-endereco *ngIf="c.tipoConsulta == 'enderecos_anteriores'" [consulta]='c'
        titulo="ENDEREÇOS ANTERIORES" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-historico-endereco>

      <app-consulta-historico-pagamento *ngIf="c.tipoConsulta == 'historico_pagamento'" [consulta]='c'
        titulo="HISTÓRICO DE PAGAMENTO" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-historico-pagamento>

      <app-consulta-capital-social *ngIf="c.tipoConsulta == 'capital_social'" [consulta]='c' titulo="CAPITAL SOCIAL"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-capital-social>

      <app-consulta-quadro-adm *ngIf="c.tipo == 'quadro_administrativo'" [consulta]='c' titulo="'QUADRO ADMINISTRATIVO'"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-quadro-adm>

      <app-consulta-controle-societario *ngIf="c.tipoConsulta == 'controle_societario'" [consulta]='c'
        titulo="CONTROLE SOCIETÁRIO" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-controle-societario>

      <app-consulta-ultimas-consultas *ngIf="c.tipoConsulta == 'ultimas_consultas'" [consulta]='c'
        titulo="'ULTIMAS CONSULTAS'" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-ultimas-consultas>

      <app-consulta-historico-consultas *ngIf="c.tipoConsulta == 'historico_consultas_realizadas'" [consulta]='c'
        titulo="HISTÓRICO DE CONSULTAS REALIZADAS" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-historico-consultas>

      <app-consulta-limite-credito-pj *ngIf="c.tipoConsulta == 'limite_credito'" [consulta]='c'
        titulo="LIMITE DE CRÉDITO" [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta"
        [codigoControle]="c.codigoControle">
      </app-consulta-limite-credito-pj>

      <app-consulta-renda-presumida *ngIf="c.tipoConsulta == 'renda_presumida'" [consulta]='c' titulo="RENDA PRESUMIDA"
        [idConsulta]="c.tipoConsulta" [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle">
      </app-consulta-renda-presumida>

      <app-consulta-cheque-sem-fundo
      *ngIf="c.tipoConsulta=='cheques_sem_fundo'" [consulta]='c' [titulo]="'CHEQUES SEM FUNDO'" [idConsulta]="c.tipoConsulta"
      [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle"></app-consulta-cheque-sem-fundo>

    </ng-container>
  </div>
</section>